module.exports = __webpack_public_path__ + "img/lesson_05.7d570f02.jpg";